module.exports = __webpack_public_path__ + "static/media/rapunzel-lose.449b6ad3.png";